// PT
export const propAuthLocksHc = {
  autoridades: {
    breadcrumbCurrent: "Autoridades competentes",
    selectorLabel: "Selecione a autoridade policial da sua região",

    // Fragmentos de status compartilhados
    msgConnected: "Conectado.",
    msgValidated: "Validado.",
    msgValidationError: "Erro de validação.",

    // SES Hospedajes
    sesSubtitle: "Secretaria de Estado de Segurança – Ministério do Interior",
    sesConnectedText: "Os check-ins serão enviados automaticamente ao SES Hospedajes.",
    sesVerifyCreds: "Verifique as credenciais informadas.",
    sesNotConnected: "Você ainda não conectou uma conta do SES Hospedajes.",
    updateConnectedAccount: "Atualizar conta conectada",

    // Ertzaintza A19
    ertzSubtitle: "Polícia Autônoma do País Basco – Registro de viajantes",
    ertzConnectedText: "Os check-ins serão enviados automaticamente à Ertzaintza.",
    ertzVerifyCif: "Verifique o CIF e o código do estabelecimento.",
    ertzCredsSaved: 'Credenciais salvas. Clique em "Verificar conexão" para conferir o acesso.',
    ertzCifLabel: "CIF do estabelecimento",
    ertzCifPlaceholder: "Ex.: B12345678",
    ertzCifHint: "Máx. 10 caracteres. CIF do locador registrado na Ertzaintza.",
    ertzCodeLabel: "Código do estabelecimento",
    ertzCodePlaceholder: "Ex.: 01000001",
    ertzCodeHint: "Atribuído pela Ertzaintza ao registrar o estabelecimento.",
    envLabel: "Ambiente",
    envPre: "Pré-produção (testes)",
    envPro: "Produção",
    envHint: 'Use "Pré-produção" para validar antes de ativar em produção.',
    verifying: "Verificando...",
    verifyConnection: "Verificar conexão",
    saving: "Salvando...",
    updateCredentials: "Atualizar credenciais",
    saveAndConnect: "Salvar e conectar",

    // Mossos d'Esquadra
    mossosSubtitle: "Generalitat de Catalunya – Registre de viatgers d'establiments d'hostalatge",

    // SIRE
    sireSubtitle: "Sistema de Informação de Registro de Estrangeiros – Migración Colombia",
    sireConnectedText: "Os check-ins serão enviados automaticamente.",
    sireRevisaCreds: "Verifique as credenciais.",
    docTypeLabel: "Tipo de documento",
    selectTypePlaceholder: "Selecione o tipo",
    docNumberLabel: "Número do documento",
    docNumberPlaceholder: "Ex.: 123456789",
    passwordLabel: "Senha",
    sirePasswordPlaceholder: "Senha SIRE",
    showHideTitle: "Mostrar/ocultar",
    saveChanges: "Salvar alterações",

    // TRA
    traSubtitle: "Ministério do Comércio, Indústria e Turismo – Token de autorização",
    traReportsText: "Relatórios automáticos habilitados.",
    traRevisaToken: "Verifique o token/RNT.",
    traTokenLabel: "Token de autorização",
    traTokenPlaceholder: "Cole aqui o token emitido pelo TRA",
    traCurrentToken: "Token atual: {token}",
    traNoTokenHint: "Se você ainda não tem um token PMS, pode gerá-lo em",
    traRntLabel: "RNT do estabelecimento",
    traRntPlaceholder: "Somente números (ex.: 123456)",
    traRntHint: "Deve ser o RNT ativo do estabelecimento (5 a 15 dígitos).",

    // Tipos de documento (Colômbia)
    docTypeCitizenId: "Cédula de cidadania",
    docTypeForeignerId: "Cédula de estrangeiro",

    // Alloggiati Web (placeholder residual)
    alloggiatiIdPlaceholder: "Ex.: 1234",

    // Toasts / mensagens de script
    needSaveListing: "Você precisa salvar o anúncio primeiro.",
    authChangedErtz: "Autoridade alterada para Ertzaintza (País Basco).",
    authChangedMossos: "Autoridade alterada para Mossos d'Esquadra (Catalunha).",
    authChangedSes: "Autoridade alterada para SES Hospedajes.",
    authChangeError: "Não foi possível alterar a autoridade.",
    ertzSaved: "Credenciais da Ertzaintza salvas.",
    saveGenericError: "Erro ao salvar.",
    ertzSaveError: "Erro ao salvar as credenciais da Ertzaintza.",
    ertzTestOk: "Conexão com a Ertzaintza verificada com sucesso.",
    testFailedCheck: "A verificação falhou. Confira os dados.",
    ertzTestError: "Erro ao verificar a conexão com a Ertzaintza.",
    mossosNeedCreds: "Informe o usuário e a senha do site dos Mossos.",
    mossosFound: "{count} estabelecimento encontrado. Escolha o seu. | {count} estabelecimentos encontrados. Escolha o seu.",
    mossosNoEstablishments: "Nenhum estabelecimento foi encontrado nesta conta.",
    mossosConnError: "Não foi possível conectar aos Mossos. Confira o usuário e a senha.",
    mossosNeedFields: "Preencha o identificador policial e o código do estabelecimento.",
    mossosSaved: "Credenciais dos Mossos salvas.",
    mossosSaveError: "Erro ao salvar as credenciais dos Mossos.",
    mossosTestOk: "Conexão com os Mossos verificada com sucesso.",
    mossosTestError: "Erro ao verificar a conexão com os Mossos.",
    mossosFileOk: "Arquivo gerado. Envie-o no site dos Mossos (Fitxers massius).",
    mossosNoTravelers: "Não há viajantes pendentes de envio.",
    mossosConfigFirst: "Configure o estabelecimento primeiro.",
    mossosFileError: "Não foi possível gerar o arquivo.",
    sireCompleteData: "Preencha os dados obrigatórios do SIRE.",
    sireSaved: "SIRE salvo com sucesso.",
    sireSaveFailed: "Não foi possível salvar o SIRE.",
    sireSaveError: "Erro ao salvar o SIRE.",
    sireDeactivated: "SIRE desativado.",
    sireActivated: "SIRE ativado.",
    sireStateFailed: "Não foi possível alterar o status do SIRE.",
    sireStateError: "Erro ao alterar o status do SIRE.",
    traNeedToken: "Informe o token e um RNT válido (somente números).",
    traSaved: "TRA salvo com sucesso.",
    traSaveFailed: "Não foi possível salvar o TRA.",
    traSaveError: "Erro ao salvar o TRA.",
    traDeactivated: "TRA desativado.",
    traActivated: "TRA ativado.",
    traStateFailed: "Não foi possível alterar o status do TRA.",
    traStateError: "Erro ao alterar o status do TRA.",
    stateChangeFailed: "Não foi possível alterar o status.",
    alloggiatiStateError: "Erro ao alterar o status do Alloggiati Web.",
    ross1000StateError: "Erro ao alterar o status do ROSS 1000.",
  },

  smartLocks: {
    loadingConfig: "Carregando configuração…",
    accessKeyTypeLabel: "Tipo de chave de acesso",
    selectLockPlaceholder: "Selecione a fechadura",
    optionStatic: "Chave Estática",
    optionTtlock: "TTLock - Fechadura Dinâmica",
    optionTedee: "Tedee - Fechadura Dinâmica",
    optionShelly: "Shelly - Relé Inteligente",
    optionYacan: "YACAN - Fechadura Inteligente",
    optionAkiles: "Akiles - Fechadura Inteligente",
    optionOther: "Outra marca que não aparece aqui…",
    pillTedee: "Acesso dinâmico (Tedee)",
    pillTtlock: "Acesso dinâmico (TTLock)",
    pillShelly: "Abertura remota (Shelly)",
    pillYacan: "Acesso gerenciado (YACAN)",
    pillAkiles: "Akiles ligado",
    pillStatic: "Acesso estático",
    pillOther: "Escreva para nós e ajudamos você a integrá-la",
    disconnecting: "Desconectando…",
    disconnect: "Desconectar",
    emptyTitle: "Conecte sua fechadura inteligente",
    emptyText: "Escolha sua marca no menu suspenso acima para conectá-la e gerar uma nova chave automática a cada reserva.",
    emptyBrandOther: "Outras marcas",
    unitFallback: "Unidade {id}",
    staticModeInfo: "Modo estático selecionado. Informe uma chave e clique em Salvar para aplicá-lo.",
    saveTypeError: "Não foi possível salvar o tipo de acesso",
    disconnectSuccess: "Fechadura desconectada",
    disconnectError: "Não foi possível desconectar a fechadura.",
  },

  rates: {
    pageTitle: "Tarifas",
    loading: "Carregando tarifas…",
    roomsCount: "{count} quarto | {count} quartos",
    singleUnit: "Unidade única",
    newBtn: "Nova",
    colName: "Nome",
    colAdjustment: "Ajuste",
    colFinal: "Preço final",
    labelMain: "Principal",
    labelDerived: "Derivada",
    base: "Base",
    editTitle: "Editar",
    copyTitle: "Copiar para outra unidade",
    deleteTitle: "Excluir",
    noDerived: "Não há tarifas derivadas para este rate plan.",
    emptyTitle: "Sem tarifas principais",
    emptyText: "Crie uma tarifa principal para esta unidade e depois você poderá criar derivadas.",
    emptyCreate: "Criar primeira tarifa principal",
    globalEmptyTitle: "Nenhuma unidade carregada",
    globalEmptyText: "Primeiro crie quartos/unidades para poder gerenciar as tarifas.",
    editRate: "Editar tarifa",
    newRate: "Nova tarifa",
    fieldName: "Nome",
    namePlaceholder: "Ex.: Tarifa flexível",
    validityPeriod: "Período de validade",
    validityPermanent: "Permanente",
    validityCustom: "Personalizado",
    validityHintCustom: "Opcional: aplica-se somente no intervalo",
    validityHintPermanent: "Tarifa válida sempre",
    startLabel: "Início",
    endLabel: "Fim",
    pricePerNight: "Preço por noite",
    taxIncluded: "Impostos incluídos",
    occupancy: "Ocupação",
    guestsNumber: "Número de hóspedes",
    minStay: "Reserva mínima",
    maxStay: "Reserva máxima",
    description: "Descrição",
    optional: "Opcional",
    rateplanBase: "Rate Plan Base",
    selectRateplanBase: "Selecione um rate plan base",
    rateplanBaseHint: "Selecione o rate plan sobre o qual esta tarifa derivada será calculada.",
    derivedNamePlaceholder: "Ex.: Booking.com, Airbnb…",
    derivedNameHint: "Este nome ajuda você a identificar a tarifa ao mapear OTAs.",
    adjustmentType: "Tipo de ajuste",
    percentage: "Porcentagem",
    fixedAmount: "Valor fixo",
    adjustmentValue: "Valor do ajuste",
    adjustmentValueHint: "(negativo para desconto)",
    preview: "Pré-visualização",
    basePrice: "Preço base",
    increment: "Acréscimo",
    discount: "Desconto",
    cancel: "Cancelar",
    saving: "Salvando...",
    update: "Atualizar",
    create: "Criar",
    deleteModalTitle: "Excluir tarifa",
    deleteWarnStrong: "Esta ação não pode ser desfeita.",
    deleteWarnLead: "Você vai excluir:",
    deleteCascadeLabel: "Excluir também suas tarifas derivadas ({count})",
    deleteCascadeHint: "Se alguma derivada estiver vinculada a uma OTA, a exclusão será bloqueada.",
    deleteConfirmLabel: "Digite o nome exato para confirmar:",
    deleteConfirmPlaceholder: "Digite exatamente o nome",
    deleteConfirmHint: "Isso evita exclusões acidentais.",
    deleting: "Excluindo...",
    deleteConfirmBtn: "Excluir definitivamente",
    copyModalTitle: "Copiar tarifa para outra unidade",
    copyOrigin: "Origem:",
    copyRate: "Tarifa:",
    copyTargetUnit: "Unidade de destino",
    selectUnit: "Selecione uma unidade",
    copySameUnitHint: "Você não pode copiar para a mesma unidade.",
    copyTargetBaseRate: "Tarifa base de destino",
    selectMainRate: "Selecione uma tarifa principal",
    copyDerivedHint: "Esta derivada será vinculada a essa tarifa principal na unidade de destino.",
    copyNoMainRates: "A unidade de destino não tem tarifas principais. Crie ou copie uma principal primeiro.",
    copyNewNameLabel: "Nome no destino",
    copyRenameHint: "Você pode renomear para evitar duplicatas.",
    copyCascadeLabel: "Copiar também as derivadas ({count})",
    copyCascadeHint: "Serão criadas novas derivadas apontando para o rate plan principal copiado.",
    copying: "Copiando...",
    copyBtn: "Copiar",

    // Toasts / mensagens de script
    loadError: "Erro ao carregar as tarifas",
    rangeErrorSelect: "Você deve selecionar um intervalo de datas válido",
    rangeErrorStartEnd: "A data de início não pode ser posterior à data de fim",
    rangeErrorMinStay: "A estadia mínima é de {minStay} noites, mas o intervalo selecionado tem {nights} noites",
    invalidUnit: "Unidade inválida",
    completeRequired: "Preencha os campos obrigatórios",
    updated: "Atualizado",
    created: "Criado",
    saveError: "Erro ao salvar",
    deleted: "Excluído",
    deleteLinkedOta: "Não é possível excluir: está vinculada a uma OTA.",
    deleteGenericError: "Erro ao excluir",
    deleteDerivedError: "Não foi possível excluir a derivada",
    copied: "Copiado",
    copyGenericError: "Erro ao copiar",
    invalidTargetUnit: "Unidade de destino inválida",
    selectTargetBaseError: "Selecione a tarifa base de destino para vincular a derivada.",
    invalidTargetBaseError: "A tarifa base de destino selecionada não é válida para a unidade de destino.",
    defaultRateName: "Tarifa",
    defaultDerivedName: "Derivada",
    copySuffix: "(Cópia)",
  },
};
